import { render, staticRenderFns } from "./MessageView.vue?vue&type=template&id=2f635ac2&scoped=true&"
import script from "./MessageView.vue?vue&type=script&lang=ts&"
export * from "./MessageView.vue?vue&type=script&lang=ts&"
import style0 from "./MessageView.vue?vue&type=style&index=0&id=2f635ac2&scoped=true&lang=less&"
import style1 from "./MessageView.vue?vue&type=style&index=1&id=2f635ac2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f635ac2",
  null
  
)

export default component.exports